<div class="row" [ngClass]="{'video-promo': displayVideo, 'display-none': !displayVideo}" >
  <div class="col-md-2 col-sm-12 button-fixed">
    <div class="bg-custom text-white">
      <button (click)="closeModal()" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      <video *ngIf="displayVideo" style="width: 100%;" poster="assets/img/video-preload.jpg" src="assets/img/video-promo.mp4" class="img-fluid video-promo" loop autoplay controls></video>
    </div>
  </div>
</div>
